import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    title: {
        marginTop: '1rem',
        padding: '.5rem',
    },
    typo: {
        fontSize: '20px',
        textAlign: 'center',
        fontWeight: 'bold'
    }
}));

// フロータイトル
function FlowTitle(props){
    const classes = useStyles();

    return(
        <Box id="flow_title" className={classes.title}>
            <Typography className={classes.typo}>{props.title}</Typography>
        </Box>
    );
}

export default FlowTitle
